module.exports = __webpack_public_path__ + "img/11_noff_close_L2.c10105f9.svg";